import BookExaminations from './BookExaminations';

export default BookExaminations;
